<div class="section">
  <app-ui-section-title [titleLevel]="'h2'" [title]="title()" [subtitle]="subtitle()"
                        [actionButtons]="actionButtons()">

  </app-ui-section-title>
  @for (subSection of subSections(); let i = $index; track i) {
    <app-ui-section-content>
      @if (shouldShowTitle(i)) {
          <app-ui-section-title
            [titleLevel]="'h3'"
            [title]="subSection.title"
            [subtitle]="subSection.subtitle"
            [actionButtons]="subSection.actionButtons"
          ></app-ui-section-title>
      }

      @switch (subSection.subSectionProps.subSectionType) {
        @case (SubSectionType.longText) {
          <app-ui-long-text
            [text]="subSection.subSectionProps.subSectionContent.text"
            [isCodeBlock]="subSection.subSectionProps.subSectionContent.isCodeBlock"
          ></app-ui-long-text>
        }
        @case (SubSectionType.keyValueGrid) {
          <app-ui-grid-key-value
            [removeEmptyFields]="subSection.subSectionProps.subSectionContent.removeEmptyFields"
            [hideEmptyTable]="subSection.subSectionProps.subSectionContent.hideEmptyTable"
            [useExplicitColumns]="subSection.subSectionProps.subSectionContent.gridOptionsOnly"
            [gridOptions]="subSection.subSectionProps.subSectionContent.gridOptions"
            [data]="subSection.subSectionProps.subSectionContent.data"
            (isGridHidden)="onShouldShowGrid(i, $event)"
          >
          </app-ui-grid-key-value>
        }
        @case (SubSectionType.regularGrid) {
          <app-ui-grid [uiGridOptions]="subSection.subSectionProps.subSectionContent"></app-ui-grid>
        }
        @case (SubSectionType.accordionContainer) {
          <div class="accordion-container">
            @for (accordion of subSection.subSectionProps.subSectionContent.accordions; let accordionIndex = $index; track accordion) {
              <app-ui-accordion
                [title]="accordion.title"
                [subtitle]="accordion.subtitle"
                [expanded]="getAccordionExpanded(i, accordionIndex, accordion.expanded ?? false)"
                (expandedChange)="setAccordionExpanded(i, accordionIndex, $event)"
              >
                @switch (accordion.content.subSectionType) {
                  @case (SubSectionType.longText) {
                    <app-ui-long-text
                      [text]="accordion.content.subSectionContent.text"
                      [isCodeBlock]="accordion.content.subSectionContent.isCodeBlock"
                    ></app-ui-long-text>
                  }
                  @case (SubSectionType.keyValueGrid) {
                    <app-ui-grid-key-value
                      [removeEmptyFields]="accordion.content.subSectionContent.removeEmptyFields"
                      [hideEmptyTable]="accordion.content.subSectionContent.hideEmptyTable"
                      [useExplicitColumns]="accordion.content.subSectionContent.gridOptionsOnly"
                      [gridOptions]="accordion.content.subSectionContent.gridOptions"
                      [data]="accordion.content.subSectionContent.data"
                      (isGridHidden)="onShouldShowGrid(i, $event)"
                    >
                    </app-ui-grid-key-value>
                  }
                  @case (SubSectionType.regularGrid) {
                    <app-ui-grid [uiGridOptions]="accordion.content.subSectionContent"></app-ui-grid>
                  }
                }
              </app-ui-accordion>
            }
          </div>
        }
      }
    </app-ui-section-content>

  }
</div>
